import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  addProjectData: [],
};

export const AddProjectDataSlice = createSlice({
  name: "addProjectData",
  initialState,
  reducers: {
    getAddProjectDataAction: (state, action) => {
      state.addProjectData = action.payload;
    },
  },
});

export default AddProjectDataSlice.reducer;

export const { getAddProjectDataAction } = AddProjectDataSlice.actions;
